import React from 'react';
import SectionTitle from '../common/SectionTitle';

const IntegrationOptions = ({paddingTop}) => {
  return (
    <>
      <section className={`feature-section-two ${paddingTop?'ptb-120':'pt-60 pb-120'} `}>
        <div className='container'>
          <div className='row align-items-center justify-content-between'>
            <div className='col-lg-6 col-md-12'>
              <SectionTitle
                subtitle='Features'
                title='Flexible integration options'
                description='We deliver an optimised payments integration with our customisable solution, tailored to your business needs.'
              />
              <div>
                <ul className='list-unstyled mt-5'>
                  <li className='d-flex align-items-start mb-4'>
                    <div className='icon-box bg-primary rounded me-4'>
                      <i className='fas fa-bezier-curve text-white'></i>
                    </div>
                    <div className='icon-content'>
                      <h3 className='h5'>Hosted payment page</h3>
                      <p>
                        We host your customisable payment page on our fully PCI DSS compliant server. This option is ideal for SME's looking to reduce their PCI DSS requirements and development work.
                      </p>
                    </div>
                  </li>
                  <li className='d-flex align-items-start mb-4'>
                    <div className='icon-box bg-black rounded me-4'>
                      <i className='fas fa-fingerprint text-white'></i>
                    </div>
                    <div className='icon-content'>
                      <h3 className='h5'>Client-side encryption</h3>
                      <p>
                        Create a superior experience with customisation and control of your online payments page while limiting your PCI compliance requirements.
                      </p>
                    </div>
                  </li>
                  <li className='d-flex align-items-start mb-4'>
                    <div className='icon-box bg-danger rounded me-4'>
                      <i className='fas fa-arrow-right-from-bracket text-white'></i>
                    </div>
                    <div className='icon-content'>
                      <h3 className='h5'>Server-to-server integration</h3>
                      <p>
                        You have total control to design a tailored payments flow for customers. This is ideal for enterprise businesses that are PCI compliant.
                      </p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div className='col-lg-6 col-md-7'>
              <div className='feature-img-wrap position-relative d-flex flex-column align-items-end'>
                <img
                  src='assets/img/feature-img3.jpg'
                  alt='feature'
                  className='img-fluid rounded-custom'
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default IntegrationOptions;
